import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import { SetWithExpiry } from "../../util/sessionManager";
import { globalize } from "../../util/Handy/Inputs/numberOnly";
import axios from 'axios';

export async function GetProducts(){
    try{
        const response = await axios.post(
            MainAddress+"visitor/read_allProducts.php",
            {
                serial_program:GetSerialProgram(),
            }
          )
    
        if(response.data[0].success ){
            console.log("products",response.data)
            SetWithExpiry("products",response.data,1000 * 3600 * 24);
            return {success:response.data[0].success};
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}

export async function GetProductGoroups(){
    try{
        const response = await axios.post(
            MainAddress+"visitor/read_productGroups.php",
            {
                serial_program:GetSerialProgram(),
            }
          )
    
        if(response.data[0].success ){
            SetWithExpiry("productGroups",response.data,1000 * 3600 * 24);
            return {success:response.data[0].success};
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}

